import { forwardRef, type InputHTMLAttributes, type SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.ts';

// שדות: ≥16px (11 §4; גם ב-index.css), 44px, מסגרת --input (≥3:1), פוקוס laser.
const base =
  'flex min-h-11 w-full rounded-sm border border-input/70 bg-card px-3 py-2 text-base text-foreground shadow-[inset_0_1px_2px_hsl(var(--shadow-color)/0.06)] transition-[border-color,box-shadow] placeholder:text-muted-foreground hover:border-input focus-visible:border-ring focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/25 disabled:opacity-50 aria-[invalid=true]:border-error aria-[invalid=true]:ring-error/20 [color-scheme:inherit]';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({ className, ...props }, ref) => (
  <input ref={ref} className={cn(base, className)} {...props} />
));
Input.displayName = 'Input';

// חץ ה-select מצויר ב-CSS (inline-end ב-RTL = שמאל), כדי שייראה זהה בכל דפדפן ובשתי הערכות.
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      base,
      'cursor-pointer appearance-none bg-[length:16px] bg-no-repeat pe-9 [background-position:left_12px_center]',
      "bg-[url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")]",
      className,
    )}
    {...props}
  />
));
Select.displayName = 'Select';

export function Label({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-sm font-semibold text-foreground/90', className)} {...props} />;
}
